import { render, staticRenderFns } from "./ContextmenuTop.vue?vue&type=template&id=47e37771&scoped=true"
import script from "./ContextmenuTop.vue?vue&type=script&lang=js"
export * from "./ContextmenuTop.vue?vue&type=script&lang=js"
import style0 from "./ContextmenuTop.vue?vue&type=style&index=0&id=47e37771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e37771",
  null
  
)

export default component.exports